import { useTranslator } from "@eo-locale/react";

import NextHead from "next/head";

import { useAppSelector } from "@/redux/store/hooks";
import { stripAllHtml } from "@/lib";
import Content from "./brainstormer/content";

const Tools = (): JSX.Element => {
  const { translate } = useTranslator();
  const { site } = useAppSelector((state) => state.site);
  const { brainstormer } = useAppSelector((state) => state.brainstormers);

  const { name, description } = brainstormer;
  return (
    <>
      <NextHead>
        <title>{`
        ${name || translate("brainstormers.idea")} | ${site.name}
      `}</title>
        {description && (
          <meta name="description" content={stripAllHtml(description)} />
        )}
      </NextHead>

      <Content />
    </>
  );
};

export default Tools;
